import React from "react";
import { Spin } from "antd";
import classNames from "classnames";
import styles from "./index.module.scss";

export default function Spinner() {
    return <Spin className={classNames("Boundary-spin", styles.spinner)} />;
}
